import { render } from "./tw-row.vue?vue&type=template&id=376cd764"
import script from "./tw-row.vue?vue&type=script&lang=js"
export * from "./tw-row.vue?vue&type=script&lang=js"
script.render = render

export default script